import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { InsideType } from '../models/inside-type';

@Injectable({
  providedIn: 'root'
})
export class InsideTypeService extends BaseService<InsideType> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string            
  ) { 
    super(http,rootUrl,'Plasard/PlasardInsideType');
  }
}